import api from "../utils/api";
const API_URL = process.env.REACT_APP_API_URL + "/skills.php";

export const getSkills = async () => {
  const res = await api.post(API_URL, { action: "getAll" });
  return res.data.skills;
};

export const getSkillById = async (id) => {
  const res = await api.post(API_URL, { action: "get", id });
  return res.data.skill;
};

export const addSkill = async (skill) => {
  const res = await api.post(API_URL, { ...skill, action: "add" });
  return res.data;
};

export const updateSkill = async (skill) => {
  const res = await api.post(API_URL, { ...skill, action: "update" });
  return res.data;
};

export const deleteSkill = async (id) => {
  const res = await api.post(API_URL, { action: "delete", id });
  return res.data;
};
export const updateSkillStatus = async (id, status) => {
  const response = await api.post(API_URL, {
    id,
    status,
    action: "updateStatus",
  });
  return response.data;
};
